export default __webpack_public_path__ + "static/media/WM0520.34I-43349_-26017_0.2ef1a86d.jpg";